export default __webpack_public_path__ + "static/media/soritoni.97bbe99a.jpeg";